import DataTable from "@/components/ui/DataTable";

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PayItemDataTable from "../../PayItemDataTable";
import { TableCell, TableRow } from "@/components/ui/table";
import TextInput from "@/components/form/TextInput";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import Dropdown, { Item } from "@/components/form/Dropdown";
import { Separator } from "@/components/ui/separator";
import { Dialog } from "@/components/ui/dialog";
import PayItemDialogContainer from "../../dialog/PayItemDialogContainer";
import { Plus } from "lucide-react";
import { OtherAdditionItem } from "@/models/other-addition-items.model";
import { OtherDeductionItem } from "@/models/other-deduction-items.model";
import AddOtherAdditionForm from "./AddOtherAdditionForm";
import AddOtherDeductionForm from "./AddOtherDeductionForm";
import { getOtherDeductionColumns } from "./other-deduction-columns";
import { getOtherAdditionColumns } from "./other-addition-columns";
import { getOtherAdditionItems } from "@/api/other-addition-items";
import { getOtherDeductionItems } from "@/api/other-deduction-items";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
}

function OthersTab({
  userId,
  month,
  year,

  payslipId,
}: Props) {
  const [otherAdditionItems, setOtherAdditionItems] = useState<
    OtherAdditionItem[]
  >([]);
  const [otherDeductionItems, setOtherDeductionItems] = useState<
    OtherDeductionItem[]
  >([]);

  useEffect(() => {
    const fetchOtherAdditionItems = async () => {
      // fetch other addition items
      const res = await getOtherAdditionItems({ userId, month, year });
      setOtherAdditionItems(res);
    };
    const fetchOtherDeductionItems = async () => {
      // fetch other deduction items
      const res = await getOtherDeductionItems({ userId, month, year });
      setOtherDeductionItems(res);
    };
    fetchOtherAdditionItems();
    fetchOtherDeductionItems();
  }, [userId, month, year]);

  const updateOtherAdditionItems = (otherAdditionItem: OtherAdditionItem) => {
    setOtherAdditionItems([...otherAdditionItems, otherAdditionItem]);
  };

  const deleteOtherAdditionItem = (id: number) => {
    const updatedItems = otherAdditionItems.filter((item) => item.id !== id);
    setOtherAdditionItems(updatedItems);
  };

  const updateOtherDeductionItems = (
    otherDeductionItem: OtherDeductionItem
  ) => {
    setOtherDeductionItems([...otherDeductionItems, otherDeductionItem]);
  };

  const deleteOtherDeductionItem = (id: number) => {
    const updatedItems = otherDeductionItems.filter((item) => item.id !== id);
    setOtherDeductionItems(updatedItems);
  };

  return (
    <div className=" w-full flex flex-row gap-10 p-5">
      {/* other addition left side */}
      <div className="w-full">
        <div className="flex justify-between">
          <div>
            <div className="text-lg font-bold">Other Additions (Non-CPF)</div>
            <div className="w-full flex flex-col">
              <div>
                Includes travel allowance, skill allowance, medical claim etc.
              </div>
            </div>
          </div>
          <PayItemDialogContainer
            title="Add Other Additions"
            description="Includes travel allowance, skill allowance, medical claim etc."
            form={
              <AddOtherAdditionForm
                userId={userId}
                month={month}
                year={year}
                payslipId={payslipId}
                updateOtherAdditionItems={updateOtherAdditionItems}
              />
            }
          />
        </div>

        <PayItemDataTable
          columns={getOtherAdditionColumns(deleteOtherAdditionItem)}
          data={otherAdditionItems}
          header="Current items"
        />
      </div>
      <Separator orientation="vertical" />

      {/* other deduction right side */}
      <div className="w-full">
        <div className="flex justify-between">
          <div>
            <div className="text-lg font-bold">Other Deductions (Non-CPF)</div>
            <div className="w-full flex flex-col">
              <div>Includes NS make-up pa, medical co-share etc.</div>
            </div>
          </div>
          <PayItemDialogContainer
            title="Add Other Deductions"
            description="Includes NS make-up pa, medical co-share etc."
            form={
              <AddOtherDeductionForm
                userId={userId}
                month={month}
                year={year}
                payslipId={payslipId}
                updateOtherDeductionItems={updateOtherDeductionItems}
              />
            }
          />
        </div>

        <PayItemDataTable
          columns={getOtherDeductionColumns(deleteOtherDeductionItem)}
          data={otherDeductionItems}
          header="Current items"
        />
      </div>
    </div>
  );
}

export default OthersTab;
